module.exports = __webpack_public_path__ + "img/Windfish-tap.efb4fc77.gif";